import { Pipe, PipeTransform, Inject } from '@angular/core';
import * as _ from 'lodash';
import { CustomFieldModel } from "../../../site-preferences/models/custom-field.model";

@Pipe({
    standalone: false,
    name: 'bringozPackageField'
})
export class BringozPackageFieldPipe implements PipeTransform {

    constructor(
        @Inject('splitService') private splitService
    ) {}

    transform(id: string): string {
        const fields: CustomFieldModel[] = this.splitService.getCustomPackageFields();

        if (!id) {
            return '';
        } else {
            const field = _.find(fields, (f: CustomFieldModel) => f.id === id);
            return field?.name || '';
        }
    }
}
